import { fromJS } from 'immutable'

const initialState = fromJS({
  title: '',
  toolsNewApp: false,
  section: '',
  showFirstSteps: true
})

const admin = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_TITLE':
      return state.merge({
        ...action.payload
      })
    case 'SHOW_TOOLS':
      return state.merge({
        toolsNewApp: action.payload.show,
        section: action.payload.section
      })
    default:
      return state
  }
}

export default admin